import { createReducer } from 'src/helpers/reducer';
import { IAgencyWorkersListState, ILoadListDataSuccessPayload } from '../types';
import actionTypes from './actionTypes';

const initState: IAgencyWorkersListState = {
  records: undefined,
  filters: [],
  isLoading: false,
  filteredCount: 0,
  totalCount: 0,
};

function onLoad(state: IAgencyWorkersListState): IAgencyWorkersListState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSuccess(
  state: IAgencyWorkersListState,
  { payload }: { payload: ILoadListDataSuccessPayload },
): IAgencyWorkersListState {
  const { records, totalCount, filteredCount, filters } = payload;

  return {
    ...state,
    records,
    totalCount,
    filteredCount,
    filters,
    isLoading: false,
  };
}

function onLoadError(state: IAgencyWorkersListState): IAgencyWorkersListState {
  return {
    ...state,
    isLoading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actionTypes.LOAD_LIST_DATA]: onLoad,
  [actionTypes.LOAD_LIST_DATA_SUCCESS]: onLoadSuccess,
  [actionTypes.LOAD_LIST_DATA_ERROR]: onLoadError,
  [actionTypes.CLEAR_STORE]: onClearStore,
});
